export default {
  'emailTemplates.title': 'Gestionar Formatos de correo',
  'emailTemplates.dowloadBaseTemplate': 'Descargar plantilla base',
  'emailTemplates.baseTemplatesZipName': 'Plantillas de Correo Base',
  'emailTemplates.mailFormat': 'Formato de Correo',
  'emailTemplates.subject': 'Asunto',
  'emailTemplates.fromName': 'Nombre Remitente',
  'emailTemplates.replyToName': 'Responder a (Nombre)',
  'emailTemplates.fileTypeClassification.html': 'HTML',
  'emailTemplates.fileTypeClassification.text': 'Texto',
  'emailTemplates.replyToEmail': 'Responder a (Email)',
  'emailTemplates.fileName': 'Nombre del archivo',
  'emailTemplates.fileType': 'Tipo de archivo',
  'emailTemplates.size': 'Tamaño',
  'emailTemplates.contentType': 'Tipo de contenido',
  'emailTemplates.eTag': 'ETag',

  // Tipos de plantilla (clave emailTemplates.type.*)
  'emailTemplates.type.accountConfirmation': 'Confirmación de Cuenta de Correo',
  'emailTemplates.type.accountResetPassword': 'Correo para Restablecer Contraseña',
  'emailTemplates.type.accountWelcomeMessage': 'Correo de Bienvenida Nuevos Usuarios',
  'emailTemplates.type.actionSendEmail': 'Formato Acción - Enviar Correo',
  'emailTemplates.type.requestApproved': 'Solicitud Aprobada',
  'emailTemplates.type.requestReassigned': 'Solicitud Reasignada',
  'emailTemplates.type.requestAttachments': 'Documentos Adjuntos',
  'emailTemplates.type.requestCanceled': 'Solicitud Cancelada',
  'emailTemplates.type.executionSteps': 'Pasos de Ejecución',
  'emailTemplates.type.requestPendingApproval': 'Aprobación Pendiente',
  'emailTemplates.type.requestPendingCompleteInformation': 'Completar Información Pendiente',
  'emailTemplates.type.requestPendingSignature': 'Firma Pendiente',
  'emailTemplates.type.requestPendingTaskCompletion': 'Pendiente Finalización de Tarea',
  'emailTemplates.type.requestRejected': 'Solicitud Rechazada',
  'emailTemplates.type.requestScheduledExecution': 'Ejecución Programada',
  'emailTemplates.type.accountTwoFactorValidationCode': 'Correo Código Validación 2-Factor',
  'emailTemplates.type.requestVoided': 'Solicitud Anulada',
  'emailTemplates.type.approvalSecurityCode': 'Aprobación - Código de Seguridad',
  'emailTemplates.type.requestWithErrors': 'Solicitud con Errores',
  'emailTemplates.type.internalTaskError': 'Tarea Interna / Error',
  'emailTemplates.type.accountSecurityAlertNewLogin':
    'Alerta de Seguridad / Nuevo Inicio de Sesión',
  'emailTemplates.type.requestNewComment': 'Solicitud / Nuevo Comentario',
  'emailTemplates.type.formFieldApiWithErrors': 'Campo API de Formulario / Con Errores',
  'emailTemplates.type.taskAssigned': 'Tarea Asignada',
  'emailTemplates.type.accountWelcomeMessageWithoutInstructions':
    'Correo de Bienvenida Nuevos Usuarios',
};
